import { CheckCircle, XCircle } from "lucide-react";
import React from "react";
import { useEffect } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";

const Notification = ({ id, message, type, onRemove }) => {
  const isMobile = useIsMobile();

  useEffect(() => {
    const timer = setTimeout(() => {
      onRemove(id);
    }, 3000);

    return () => clearTimeout(timer);
  }, [id, onRemove]);

  const bgClass = type === 1 ? "bg-green-500" : "bg-red-500";
  const Icon = type === 1 ? CheckCircle : XCircle;

  return (
    <div
      className={`${bgClass} ${
        isMobile ? "max-w-[100vw]" : "max-w-[30vw]"
      } w-max text-white px-4 py-3 rounded-lg shadow-lg mb-2 flex items-center space-x-3 animate-slide-up animate-fade-in`}
    >
      <Icon className={`w-6 h-6 text-white`} />
      <p className="flex-1 whitespace-pre-wrap">{message}</p>
    </div>
  );
};

export default Notification;
